module.exports = __webpack_public_path__ + "static/media/ghost.8d83a5b4.svg";